import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { accountActions } from "./actions";
import { AccountState } from "./types";

const initialState: AccountState = {
    isLoading: false,
    changePasswordSuccess: false,
    changePasswordError: null,
};

export function AccountReducer(state = initialState, action: Action): AccountState {
    if (isType(action, accountActions.changePassword.started)) {
        return {
            ...state,
            isLoading: true,
            changePasswordSuccess: false,
            changePasswordError: null,
        };
    }

    if (isType(action, accountActions.changePassword.done)) {
        return {
            ...state,
            isLoading: false,
            changePasswordSuccess: true,
            changePasswordError: null,
        };
    }

    if (isType(action, accountActions.changePassword.failed)) {
        let errorMessage = "Failed to change password";

        // Extract error message from the API response
        const error = action.payload.error as any;
        if (error?.response?.data) {
            const errorData = error.response.data;
            if (typeof errorData === 'string') {
                errorMessage = errorData;
            } else if (errorData && typeof errorData === 'object') {
                if ('detail' in errorData && errorData.detail) {
                    errorMessage = errorData.detail;
                } else if ('message' in errorData && errorData.message) {
                    errorMessage = errorData.message;
                } else {
                    errorMessage = JSON.stringify(errorData);
                }
            }
        } else if (error?.message) {
            errorMessage = error.message;
        }

        return {
            ...state,
            isLoading: false,
            changePasswordSuccess: false,
            changePasswordError: errorMessage,
        };
    }

    if (isType(action, accountActions.resetToInitialState)) {
        return initialState;
    }

    return state;
} 